<template>
  <div :class="[$style.promoCard, $style[type]]" @click.prevent="$emit('cardClick')">
    <!-- :class="[
        $style.promoCardRight,
        {
          [$style.promoCardRightGray]:
            type === 'modal' &&
            statusData &&
            (status === EBonusStatus.locked || status === EBonusStatus.missed),
        },
      ]" -->
    <div
      :class="[
        $style.promoCardRight,
        {
          [$style.promoCardRightGray]:
            statusData && (status === EBonusStatus.locked || isComingSoonMode),
        },
      ]"
    >
      <img
        :class="[
          $style.promoCardImageFront,
          {
            [$style.promoCardImageComingSoonMode]: isComingSoonMode,
          },
        ]"
        fetchpriority="high"
        loading="lazy"
        :src="`${imageFront.url}?w=1200&q=80&fit=cover&format=webp`"
        alt="promotionCard"
      />
      <img
        v-if="imageBack.url"
        :class="$style.promoCardImageBack"
        :src="imageBack.url"
        alt="imageBack"
      />
      <template v-if="type === 'modal'">
        <div :class="$style.promoCardLeft">
          <div :class="$style.promoCardLeftTopContent">
            <p :class="$style.promoCardOffer">
              {{ offer }}
            </p>
            <p v-if="title" :class="$style.promoCardTitle">{{ title }}</p>
            <div v-if="timerEndTime && isAuthorised" :class="$style.promoCardMiddleContent">
              <BitTimer
                :start-time="Date.now()"
                :end-time="new Date(timerEndTime).getTime()"
                :is-background="false"
                :title-days="components.timer.daysTitle"
                :title-hours="components.timer.hoursTitle"
                :title-minutes="components.timer.minutesTitle"
                :title-seconds="components.timer.secondsTitle"
                class="promoCardTimer"
              >
                {{ timerTitle }}:
              </BitTimer>
            </div>
          </div>
          <div
            v-if="statusData"
            :class="[
              $style.promoCardStatusBlock,
              $style[statusData.status],
              { [$style.promoCardStatusBlockNoModal]: type === 'default' },
            ]"
          >
            <img v-if="statusData.statusIcon" :src="statusData.statusIcon" alt="statusIcon" />
            <p>
              {{ statusData.statusText }}
            </p>
          </div>
        </div>
      </template>
    </div>

    <div v-if="type !== 'modal'" :class="$style.promoCardLeft">
      <div :class="$style.promoCardLeftTopContent">
        <p :class="$style.promoCardOffer">
          {{ offer }}
        </p>
        <p v-if="title" :class="$style.promoCardTitle">{{ title }}</p>
        <div v-if="timerEndTime && isAuthorised" :class="$style.promoCardMiddleContent">
          <BitTimer
            :start-time="Date.now()"
            :end-time="new Date(timerEndTime).getTime()"
            :is-background="false"
            :title-days="components.timer.daysTitle"
            :title-hours="components.timer.hoursTitle"
            :title-minutes="components.timer.minutesTitle"
            :title-seconds="components.timer.secondsTitle"
            class="promoCardTimer"
          >
            {{ timerTitle }}:
          </BitTimer>
        </div>
        <div
          v-if="statusData"
          :class="[
            $style.promoCardStatusBlock,
            $style[statusData.status],
            { [$style.promoCardStatusBlockNoModal]: type === 'default' },
          ]"
        >
          <img v-if="statusData.statusIcon" :src="statusData.statusIcon" alt="" />
          <p>
            {{ statusData.statusText }}
          </p>
        </div>
      </div>
      <template v-if="type === 'modal'">
        <BitButton
          v-if="isHideAuthorisedContent"
          is-fluid-width
          :class="$style.promoCardActionButton"
          width-size="md"
          @click.stop="openSignupModal"
        >
          {{ signUpButton }}
        </BitButton>
        <BitButton
          v-else-if="isStatusActive"
          :class="$style.promoCardActionButton"
          is-fluid-width
          width-size="md"
          @click.stop="$emit('buttonClick')"
        >
          {{ isActiveCrmBonus ? deactivateButtonTitle : activeButtonTitle }}
        </BitButton>
        <BitButton
          v-else-if="type !== 'modal' && lockedButtonTitle"
          :class="$style.promoCardActionButton"
          is-fluid-width
          type="secondary"
          width-size="md"
          @click.stop="$emit('cardClick')"
        >
          {{ lockedButtonTitle }}
        </BitButton>
      </template>
    </div>
    <template v-if="type === 'modal'">
      <BitButton
        v-if="isHideAuthorisedContent"
        is-fluid-width
        :class="$style.promoCardActionButton"
        width-size="md"
        @click.stop="openSignupModal"
      >
        {{ signUpButton }}
      </BitButton>
      <BitButton
        v-else-if="isStatusActive"
        :class="$style.promoCardActionButton"
        type="secondary"
        is-fluid-width
        width-size="md"
        @click.stop="$emit('buttonClick')"
      >
        {{ isActiveCrmBonus ? deactivateButtonTitle : activeButtonTitle }}
      </BitButton>
      <BitButton
        v-else-if="type !== 'modal' && lockedButtonTitle"
        :class="$style.promoCardActionButton"
        is-fluid-width
        type="secondary"
        width-size="md"
        @click.stop="$emit('cardClick')"
      >
        {{ lockedButtonTitle }}
      </BitButton>
    </template>
    <div v-if="type !== 'modal'" :class="$style.promoCardLabelsHolder">
      <BitCardLabel :class="$style.promoCardLabel" :custom-color="ribbonColor">
        {{ ribbonTitle }}
      </BitCardLabel>
      <BitCardLabel
        v-if="additionalLabelData"
        :class="$style.promoCardLabel"
        :custom-color="additionalLabelData.color"
      >
        {{ additionalLabelData.text }}
      </BitCardLabel>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitButton, BitTimer, BitCardLabel } from '@bit/ui-kit';

import { useStoreModals } from '~/stores/abstract/modals';
import { useStoreSsPlayer } from '~/stores/softswiss/player';
import { useStoreButtonTitles } from '~/stores/strapi/buttonTitles';
import { useStoreComponents } from '~/stores/strapi/components';
import { EBonusStatus } from '~/types/bonuses';
import { type IStrapiImage } from '~/types/strapiImage';
import type { PromoStatusData } from '../types';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  type: {
    type: String as PropType<'default' | 'modal'>,
    default: 'default',
  },
  imageFront: {
    type: Object as PropType<IStrapiImage>,
    required: true,
  },
  imageBack: {
    type: Object as PropType<IStrapiImage>,
    required: false,
    default: () => ({}),
  },
  offer: {
    type: String,
    required: true,
  },
  timerEndTime: {
    type: Date,
    default: undefined,
  },
  timerTitle: {
    type: String,
    default: '',
  },
  promocode: {
    type: String,
    default: '',
  },
  activeButtonTitle: {
    type: String,
    required: true,
  },
  lockedButtonTitle: {
    type: String,
    default: '',
  },
  isBlockedForGuests: {
    type: Boolean,
    default: false,
  },
  ribbonTitle: {
    type: String,
    default: '',
  },
  ribbonColor: {
    type: String,
    default: '',
  },
  activeButtonGtm: {
    type: String,
    default: null,
  },
  guestButtonGtm: {
    type: String,
    default: null,
  },
  status: {
    type: String as PropType<EBonusStatus>,
    default: '',
  },
  statusData: {
    type: Object as PropType<PromoStatusData>,
    default: null,
  },
  isActiveCrmBonus: {
    type: Boolean,
    default: false,
  },
  isComingSoonMode: {
    type: Boolean,
    default: false,
  },
  additionalLabelData: {
    type: Object as PropType<{ text: string; color: string }>,
    default: null,
  },
});
defineEmits<{
  (e: 'cardClick'): void;
  (e: 'buttonClick'): void;
}>();

const storeSsPlayer = useStoreSsPlayer();
const storeButtons = useStoreButtonTitles();
const storeModals = useStoreModals();
const components = useStoreComponents();

const isHideAuthorisedContent = computed(
  () => !storeSsPlayer.isPlayerAuthorised && props.isBlockedForGuests
);
const isStatusActive = computed(
  () =>
    props.status !== EBonusStatus.done &&
    props.status !== EBonusStatus.locked &&
    props.status !== EBonusStatus.missed
);

const signUpButton = computed(() => storeButtons.signup);
const isAuthorised = computed(() => storeSsPlayer.isPlayerAuthorised);
const deactivateButtonTitle = computed(() => storeButtons.deactivate);

const openSignupModal = () => {
  storeModals.openLoginOrSignupModal({ button_place: 'bonus_promo' });
};
</script>

<style lang="scss" module src="./promoCard.scss"></style>
